import { createSlice } from "@reduxjs/toolkit";

const LoginSlice = createSlice({
  name: "store",
  initialState: {
    Store: null,
  },
  reducers: {
    LoginSuccess: (state, action) => {
      state.Store = action.payload;
    },

    Logout: (state) => {
      state.Store = null;
    },
  },
});

export const { LoginSuccess, Logout } = LoginSlice.actions;
export default LoginSlice.reducer;
